export enum CompanyActionEnum {
  SSO_LOGIN = 'SSO_LOGIN',
  PASSWORD_LOGIN = 'PASSWORD_LOGIN',
}
